var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpecialoffer2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 352,
    height: 352,
    viewBox: "0 0 352 352",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3501_685)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.002 250.265C182.507 250.265 187.781 244.991 187.781 238.486C187.781 231.981 182.507 226.707 176.002 226.707C169.496 226.707 164.223 231.981 164.223 238.486C164.223 244.991 169.496 250.265 176.002 250.265Z",
    fill: "#C74141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.002 125.292C182.507 125.292 187.781 120.019 187.781 113.513C187.781 107.008 182.507 101.734 176.002 101.734C169.496 101.734 164.223 107.008 164.223 113.513C164.223 120.019 169.496 125.292 176.002 125.292Z",
    fill: "#C74141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.511 9.49781C336.394 3.37287 328.257 0 319.596 0H196.198C187.542 0 179.403 3.3715 173.282 9.49369L9.49506 173.28C3.3715 179.403 0 187.541 0 196.195C0 204.851 3.37288 212.989 9.49506 219.107L132.89 342.503C139.01 348.627 147.148 352 155.804 352C164.459 352 172.597 348.629 178.72 342.505L342.506 178.718C348.629 172.597 352 164.458 352 155.802V32.4039C352 23.7435 348.627 15.6049 342.511 9.49781ZM176.001 81.1092C193.868 81.1092 208.405 95.6457 208.405 113.513C208.405 131.381 193.868 145.917 176.001 145.917C158.133 145.917 143.597 131.381 143.597 113.513C143.597 95.6457 158.133 81.1092 176.001 81.1092ZM176.001 270.889C158.133 270.889 143.597 256.353 143.597 238.486C143.597 220.618 158.133 206.082 176.001 206.082C193.868 206.082 208.405 220.618 208.405 238.486C208.405 256.353 193.868 270.889 176.001 270.889ZM242.275 186.312H109.726C104.031 186.312 99.4139 181.695 99.4139 175.999C99.4139 170.304 104.031 165.687 109.726 165.687H242.275C247.97 165.687 252.587 170.304 252.587 175.999C252.587 181.695 247.971 186.312 242.275 186.312ZM286.459 75.8539C280.766 75.8539 276.146 71.2339 276.146 65.5414C276.146 59.8489 280.766 55.2289 286.459 55.2289C292.151 55.2289 296.771 59.8489 296.771 65.5414C296.771 71.2339 292.151 75.8539 286.459 75.8539Z",
    fill: "#C74141"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3501_685"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 352,
    height: 352,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecialoffer2);
export default __webpack_public_path__ + "static/media/specialoffer2.8a5ae8505e7013b651252305cbb87117.svg";
export { ForwardRef as ReactComponent };